import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import throttle from 'lodash/throttle';

// Components
import Intro from 'components/common/Intro';
import * as options from 'constants/SelectsOptions';
import Tabs from 'components/common/Tabs';
import Globe from 'components/common/globe';
import DownloadModule from 'components/common/DownloadModule';
import ToolsBar from 'components/common/ToolsBar';
import Footer from 'components/common/Footer';
import * as queryString from 'query-string';
// Country profile components
import LegendTraffic from './LegendTraffic';
import CountryDescription from './CountryDescription';
import OverallCharts from './OverallCharts';
import PerformanceHighlights from './PerformanceHighlights';
import SpecialInstitutions from './SpecialInstitutions';
import GraphType from './GraphType';
import SectorsComparison from './SectorsComparison';
import Footnote from './Footnote';
import LegendTrafficMobile from './LegendTrafficMobile';

import { roundNumber } from 'utils/general';
import { parseCompareSectorData, getLawPracticeGraphData, getAvailableYears, getUniqueSectorsName } from 'utils/countryProfile';
import { getCountrySectorScores, getScoreData } from 'utils/data';
import Recommendations from './Recommendations';
class DataDetailPage extends React.Component {
  constructor(props) {
    super(props);

    // Here you have the available options http://react-component.github.io/collapse/#api.
    this.accordionOptions = {
      accordion: true,
      activeKey: []
    };

    // Flag to know if we have already set the sector in the url when updating.
    // The sector stays in the store so we can not properly check it in the "componentWillRecieveProps"
    this.setSectorToUrl = false;

    this.sectors = {
      mining: 'mining',
      'oil-gas': 'oil & gas'
    };

    // Bindings
    this.handleSectorChange = this.handleSectorChange.bind(this);
    this.onScrollLegend = throttle(this.onScrollLegend, 40).bind(this);
  }

  componentWillMount() {
    this.getCountryAllData();
    this.props.getAverages();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScrollLegend);
    const { filters } = this.props;
    this.props.getActiveYears();
    let paramsFilter = {};
    if (filters.years && filters.years.length) {
      paramsFilter = { ...paramsFilter, years: filters.years.join(',') };
    }
    const route = this.props.router.getCurrentLocation();
    const { pathname } = route;
    const filterParams = queryString.stringify(paramsFilter);
    this.props.router.replace(`${pathname}?${filterParams}`);
  }

  componentWillReceiveProps(nextProps) {
    const { filters = {}, years: availableYears } = this.props;
    let { years = [] } = filters;
    let paramsFilter = {};
    const queryYears = (nextProps.routeParams.query || {}).years || [];
    if (queryYears && queryYears.length) {
      years = nextProps.routeParams.query.years;
    }
    let urlYearsChangeRequired = false;
    if (availableYears && availableYears.length) {
      urlYearsChangeRequired = years.filter(el => !availableYears.includes(String(el))).length > 0;
      years = years.filter(el => availableYears.includes(String(el)));
      if (!years.length) {
        years = [availableYears[0]];
        urlYearsChangeRequired = true;
      }
      if (urlYearsChangeRequired) {
        this.props.setDataFilters({
          sector: nextProps.routeParams.sector,
          years
        });
      }
    }
    if (years && years.length) {
      paramsFilter = { ...paramsFilter, years: years.join(',') };
    }

    const filterParams = queryString.stringify(paramsFilter);
    if (
      this.props.routeParams.sector !== nextProps.routeParams.sector &&
      nextProps.sectors.includes(nextProps.routeParams.sector)
    ) {
      this.props.setDataFilters({
        sector: nextProps.routeParams.sector,
        years
      });
      this.props.getCountryProfileReport(this.props.routeParams.country, years);
    } else if (
      !nextProps.sectors.includes(nextProps.routeParams.sector) &&
      nextProps.sectors.length
    ) {
      urlYearsChangeRequired = false;
      this.props.setDataFilters({ sector: nextProps.sectors[0], years });
      this.props.getCountryProfileReport(this.props.routeParams.country, years);
      this.props.router.replace(
        `/country-profiles/${nextProps.country}/${nextProps.sectors[0]}?${filterParams}`
      );
    }
    if (this.props.routeParams.country !== nextProps.routeParams.country) {
      this.getCountryAllData();
    }
    if (this.props.filters.sector !== nextProps.filters.sector || urlYearsChangeRequired) {
      this.props.router.replace(
        `/country-profiles/${nextProps.country}/${nextProps.filters.sector}?${filterParams}`
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScrollLegend);
  }
  onReportDownload(info, sector, year) {
    if (!info) return;
    const selectedDocument = this.isDocumentExist(info, sector, year);
    if (selectedDocument) { window.open(selectedDocument.document, '_blank'); }
  }
  onScrollLegend() {
    const generalInfo = document.getElementsByClassName(
      'country-general-info'
    )[0];
    const legend = document.getElementsByClassName('c-legend-traffic')[0];
    const containerHeight = generalInfo.offsetHeight;
    const containerPosition = generalInfo.getBoundingClientRect().top;

    if (containerPosition + containerHeight - legend.offsetHeight - 100 <= 0) {
      legend.style.position = 'absolute';
      legend.style.top = 'auto';
      legend.style.bottom = '0';
    } else if (containerPosition <= 60) {
      legend.style.position = 'fixed';
      legend.style.top = '100px';
      legend.style.bottom = 'auto';
    } else {
      legend.style.position = 'absolute';
      legend.style.top = '60px';
      legend.style.bottom = 'auto';
    }
  }

  onDownloadReport() {
    this.props.router.push('/publications-data/downloads');
  }

  getCountryAllData() {
    const iso = this.props.routeParams.country;
    const { years = [] } = this.props.routeParams.query || this.props.filters;
    this.props.getCountryInfo(iso);
    this.props.setCountry(iso);
    this.props.getCountries();
    this.props.setDataFilters({ sector: this.props.routeParams.sector, years });
    this.props.getCountryProfileReport(iso, years);
  }

  getOpositeSector() {
    const a = this.props.sectors.slice(0);
    const c = a.indexOf(this.props.routeParams.sector);

    if (c > -1) {
      a.splice(c, 1);
    }

    return a;
  }

  getCompareSectors() {
    const currentSector = parseCompareSectorData(
      this.props.dataReport,
      this.props.filters.sector
    );

    const otherSector = this.props.compareData.otherSector;
    return [currentSector, otherSector];
  }

  getScoreOrNull(score) {
    return score !== null ? roundNumber(score) : null;
  }
  getFilterYear() {
    const { years } = this.props.filters || {};
    return years && years.length ? years[0] : '';
  }
  getScoreKey() {
    const scoreKey = `score${this.getFilterYear()}`;
    return scoreKey;
  }
  getGraphTypeData(data) {
    const selectedYear = this.getFilterYear();
    return getLawPracticeGraphData(data, selectedYear);
  }
  getCountrySectoryearDataInfo(selectedYear) {
    const dataReport = this.props.dataReport || {};
    return (dataReport['country-sector-year-data'] || []).find(el => String(el.year) === selectedYear) || {};
  }
  isDocumentExist(info, sector, year) {
    if (!info.documents || !info.documents.length) return null;
    const selectedDocument = info.documents.find(el => el.sector === sector && el.year === year) || {};
    return selectedDocument.document ? selectedDocument : null;
  }

  handleSectorChange(option) {
    const iso = this.props.country;
    this.props.router.push(`/country-profiles/${iso}/${option.value}`);
  }
  removeUndefinedValues(obj, key) {
    if (Array.isArray(obj)) return obj.filter(el => el[key]);
    const updatedObjKeys = Object.keys(obj).filter(el => obj[el][key]);
    const filteredObj = {};
    updatedObjKeys.forEach(el => {
      filteredObj[el] = obj[el];
    });
    return filteredObj;
  }

  overallParseData() {
    const sectorData = this.props.dataReport;
    const averages = this.props.averages;
    const scoreKey = this.getScoreKey();
    if (Object.keys(sectorData).length) {
      const scoreData = { ...getScoreData(getCountrySectorScores(sectorData)) };

      const compositeValues = {
        label: 'Composite',
        value: this.getScoreOrNull(scoreData[scoreKey]),
        avg: this.getScoreOrNull(averages.composites && averages.composite.length ? averages.composite[0].average : null)
      };
      const categories =
        sectorData['country-sector-categories'].map((cat) => {
          const categoryAvg = averages.categories.find(
            (c) => cat.category.name === c.name
          );
          const catScoreObj = getScoreData(cat);
          return {
            label: cat.category.name,
            value: this.getScoreOrNull(catScoreObj[scoreKey]),
            avg: categoryAvg ? this.getScoreOrNull(categoryAvg.average) : null
          };
        }) || [];

      return { main: compositeValues, components: this.removeUndefinedValues(categories, 'value') };
    }
    return {};
  }

  highlightParseData() {
    const sectorData = this.props.dataReport;

    if (Object.keys(sectorData).length) {
      const charts = [];
      const scoreKey = this.getScoreKey();
      sectorData['country-sector-categories'].forEach((cat) => {
        const chart = [];
        const bestCat = this.props.averages.categories.find(
          (c) => c.name === cat.category.name
        );
        const categoryScoreObj = getScoreData(cat);
        chart.push({
          score: categoryScoreObj[scoreKey],
          name: cat.category.name,
          best: bestCat ? bestCat.max : null
        });
        cat['country-sector-subcategories'].forEach((subcat) => {
          const bestSub = this.props.averages.subcategories.find(
            (s) => s.name === subcat.subcategory.name
          );
          const subcategoryScoreObj = getScoreData(subcat);
          chart.push({
            score: subcategoryScoreObj[scoreKey],
            name: subcat.subcategory.name,
            best: bestSub ? bestSub.max : null
          });
        });

        charts.push(chart);
      });
      return charts;
    }
    return [];
  }
  highlightComponentsTableData() {
    const sectorData = this.props.dataReport;
    if (Object.keys(sectorData).length) {
      const tableData = [];
      const scoreKey = this.getScoreKey();
      sectorData['country-sector-categories'].forEach((cat) => {
        const singleComponentData = [];
        let component = {};
        const categoryScoreObj = getScoreData(cat);
        component = {
          ...component,
          score: roundNumber(categoryScoreObj[scoreKey], '.'),
          name: cat.category.name
        };
        singleComponentData.push(component);
        cat['country-sector-subcategories'].forEach((subcat) => {
          const subCategoryScoreObj = getScoreData(subcat);
          singleComponentData.push({
            score: roundNumber(subCategoryScoreObj[scoreKey], '.'),
            name: subcat.subcategory.name,
            isSubComponent: true
          });
        });
        tableData.push(singleComponentData);
      });
      return tableData;
    }
    return [];
  }
  availableYears() {
    const sectorData = this.props.dataReport;
    return getAvailableYears(sectorData);
  }
  highlightParseCountryData() {
    const sectorData = this.props.dataReport;
    const chart = [];

    if (Object.keys(sectorData).length) {
      const scoreData = { ...getScoreData(getCountrySectorScores(sectorData)) };
      let yearsArr = this.availableYears();
      if (yearsArr && yearsArr.length < 2) return [];
      if (yearsArr && yearsArr.length >= 2) yearsArr = yearsArr.slice(0, 3).reverse();
      yearsArr.forEach((y) => {
        const addedYears = [];
        const scoreKey = Object.keys(scoreData).find((el) => el.includes(y));
        if (!scoreKey || !scoreData[scoreKey]) return;

        if (!addedYears.includes(y)) {
          chart.push({ score: scoreData[scoreKey], name: y });
          addedYears.push(y);
        }
      });
      return chart;
    }
    return [];
  }

  handleParamChange(param, value) {
    const { router } = this.props;
    const route = router.getCurrentLocation();
    const { pathname } = route || {};
    let paramsFilters = {};
    if (pathname) {
      paramsFilters = {
        ...paramsFilters,
        years: value
      };
      if (param === 'years') {
        paramsFilters = queryString.stringify(paramsFilters);
        router.replace(`${pathname}?${paramsFilters}`);
      }
    }
  }

  orderSpecialInstitutions(sectorInfo) {
    return sectorInfo['special-institutions'].sort((a, b) => {
      const x = a['institution-type'].toLowerCase();
      const y = b['institution-type'].toLowerCase();

      if (x < y) return 1;
      if (x > y) return -1;
      return 0;
    });
  }


  transformDataForSelectedYear(dataObj) {
    const scoreKey = this.getScoreKey();
    const scoreDataObj = getScoreData(dataObj);
    return { ...dataObj, score: scoreDataObj[scoreKey] || scoreDataObj.score };
  }
  compareParseData() {
    const sectors = this.getCompareSectors();
    const currentSector = sectors[0];
    const otherSector = sectors[1];
    // console.log('current sector othersector', currentSector, otherSector)
    const scoreKey = this.getScoreKey();
    if (Object.keys(currentSector).length && Object.keys(otherSector).length) {
      const charts = [
        [
          {
            value1: this.getScoreOrNull(currentSector[scoreKey]),
            value2: this.getScoreOrNull(otherSector[scoreKey]),
            name: 'Composite'
          }
        ]
      ];

      currentSector.categories.forEach((cat) => {
        if (cat.category.name !== 'Enabling environment') {
          const chart = [];

          const otherSectorCat = otherSector.categories.find(
            (c) => c.category.name === cat.category.name
          );
          if (!otherSectorCat) return;
          chart.push({
            value1: this.getScoreOrNull(cat[scoreKey]),
            value2: this.getScoreOrNull(otherSectorCat[scoreKey]),
            name: cat.category.name
          });

          cat['country-sector-subcategories'].forEach((subcat) => {
            const otherSectorSubcat = otherSectorCat[
              'country-sector-subcategories'
            ].find((s) => s.subcategory.name === subcat.subcategory.name);

            if (otherSectorSubcat) {
              chart.push({
                value1: this.getScoreOrNull(subcat[scoreKey]),
                value2: this.getScoreOrNull(otherSectorSubcat[scoreKey]),
                name: subcat.subcategory.name
              });
            }
          });

          charts.push(chart);
        }
      });
      return charts;
    }
    return [];
  }

  render() {
    const { years: countryAvailableYears } = this.props;
    const { years: selectedYears = [] } = this.props.filters || {};
    const selectedYear = selectedYears.length && countryAvailableYears.length ? String(selectedYears[0]) : '';
    const availableYears = this.availableYears();
    const { info } = this.props;
    const sector = this.props.router.params.sector || this.props.sectors[0];
    // const sectorInfo =
    //   (this.props.info.sectorsInfo &&
    //     this.props.info.sectorsInfo.find((s) => s.name === sector && String(s.year) === selectedYear)) ||
    //   {};
    const sectorInfo = this.getCountrySectoryearDataInfo(selectedYear);
    this.opositeSector =
      this.props.sectors.length > 1 && this.props.routeParams.sector
        ? this.getOpositeSector()
        : '';
    const isDualSector = this.props.sectors.length === 2;
    const titleName = `${this.props.info.country || ''}${
      isDualSector ? ` (${this.sectors[sector]})` : ''
    }`;

    return (
      <div className={`c-country-profile l-main -${sector}`}>
        {this.props.info && (
          <Intro section="country-profile" theme={sector}>
            <div className="row ">
              <div className="column hide-for-small-only small-1 medium-2 no-print">
                <Globe
                  theme="-light -thin"
                  selectedCountry={this.props.country}
                  interactivity={false}
                />
              </div>
              <div className="column small-12 medium-4 intro-title">
                <h2 className="title -section-title -light">
                  {this.props.info.country}
                </h2>
                <p className="subtitle -light">{this.sectors[sector]}</p>
              </div>
              <div className="column small-12 medium-6  no-print">
                <div className="row">
                  <div className="column small-12">
                    <ToolsBar
                      setModalContent={this.props.setModalContent}
                      isPrint={!this.isDocumentExist(this.props.info, sector, selectedYear)}
                      downloadText="Download Country Profile"
                      onDownload={() => this.onReportDownload(this.props.info, sector, selectedYear)}
                      activeYears={this.props.activeYears}
                      selectedYears={selectedYears}
                    />
                  </div>

                  <div className="column small-12 large-8 large-offset-3">
                    <Tabs
                      value={sector}
                      options={options.countrySectors}
                      disabledValues={this.props.sectors && options.countrySectors.filter(el => !this.props.sectors.includes(el.value)).map(el => el.value)}
                      onChange={this.handleSectorChange}
                      theme={sector}
                      wrapperClass={'-v-offset'}
                    />
                  </div>

                  <div className="column small-12 large-8 large-offset-3">
                    <Tabs
                      value={selectedYear}
                      options={options.allYears}
                      disabledValues={options.allYears.filter(el => !availableYears.includes(el.value)).map(el => el.value)}
                      onChange={(option) => {
                        this.handleParamChange('years', option.value);
                        this.props.getGraphData(this.getCountrySectoryearDataInfo(option.value)['graph-type']);
                      }}
                      theme={sector}
                      wrapperClass={'-v-offset'}
                    />
                  </div>
                </div>
              </div>

            </div>
          </Intro>
        )}

        <section
          ref={(n) => (this.generalInfo = n)}
          className="country-general-info"
        >
          <LegendTraffic />

          <div className="row">
            {/* Country description */}
            <CountryDescription
              data={this.highlightParseCountryData()}
              description={sectorInfo.description}
              keyMessages={sectorInfo.message}
              name={info.country}
              sector={sector}
              titleName={titleName}
            />

            {/* Overall charts */}
            <OverallCharts
              data={this.overallParseData()}
              titleName={titleName}
              showAverage={selectedYear === '2017'}
            />

            {/* Performance highlights */}
            <PerformanceHighlights
              info={{
                title: sectorInfo['performance-title'],
                textTop: sectorInfo['performance-highlights-top'],
                textBottom: sectorInfo['performance-highlights-bottom'],
                titleName
              }}
              data={this.highlightComponentsTableData()}
              // data={this.highlightParseData()}
            />

            {/* Graph type */}
            <GraphType
              country={info.country}
              sector={sector}
              titleName={titleName}
              data={this.getGraphTypeData(this.props.graphTypeData)}
              type={sectorInfo['graph-type']}
              text={sectorInfo['graph-text']}
            />

            {/* Special institutions */}
            {sectorInfo['special-institutions'] &&
              this.orderSpecialInstitutions(sectorInfo).map((inst, i) => (
                <SpecialInstitutions key={i} data={this.transformDataForSelectedYear(inst)} sector={sector} />
              ))}

            {/* Sectors comparison */}
            {info.sectorsInfo && getUniqueSectorsName(info.sectorsInfo).length === 2 && (
              <SectorsComparison
                info={{
                  title: sectorInfo['comparison-title'],
                  description: sectorInfo['comparison-description'],
                  country: info.country,
                  sectors: this.getCompareSectors().map((s) =>
                    s.name ? this.sectors[s.name] : ''
                  )
                }}
                data={this.compareParseData()}
              />
            )}
            {
              sectorInfo.recommendation ? <Recommendations data={{ recommendations: sectorInfo.recommendation }} /> : null
            }

            {/* Footnote */}
            <Footnote data={{ footnote: sectorInfo.footnote }} />
          </div>
        </section>
        <DownloadModule
          title="Download the RGI dataset"
          onDownload={() => this.onDownloadReport()}
          buttonText="Go to Downloads"
        />
        <LegendTrafficMobile />
        <Footer />
        <div className="c-tooltip-graph"></div>
      </div>
    );
  }
}

DataDetailPage.propTypes = {
  router: PropTypes.object.isRequired,
  country: PropTypes.string.isRequired,
  data: PropTypes.any.isRequired,
  graphTypeData: PropTypes.any,
  dataReport: PropTypes.object.isRequired,
  years: PropTypes.array,
  info: PropTypes.object,
  compareData: PropTypes.object,
  routeParams: PropTypes.any,
  sectors: PropTypes.array,
  filters: PropTypes.object,
  countries: PropTypes.array.isRequired,
  totalAssestments: PropTypes.number,
  averages: PropTypes.object,
  activeYears: PropTypes.array,
  /* Functions */
  getCountryProfileReport: PropTypes.func.isRequired,
  getActiveYears: PropTypes.func.isRequired,
  getCountryInfo: PropTypes.func.isRequired,
  getAverages: PropTypes.func.isRequired,
  getCountries: PropTypes.func.isRequired,
  setCountry: PropTypes.func.isRequired,
  setDataFilters: PropTypes.func.isRequired,
  setModalContent: PropTypes.func,
  getGraphData: PropTypes.func
};

export default withRouter(DataDetailPage);



// WEBPACK FOOTER //
// ./app/components/country-profiles/show/index.jsx